<h2 mat-dialog-title>Set Document Dates</h2>
<mat-dialog-content class="dialog-content">
  <p><strong>Document Title:</strong> {{ data.selectedTitle }}</p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Renewal Date</mat-label>
    <input matInput [matDatepicker]="renewalPicker" [(ngModel)]="renewalDate">
    <mat-datepicker-toggle matSuffix [for]="renewalPicker"></mat-datepicker-toggle>
    <mat-datepicker #renewalPicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Due Date</mat-label>
    <input matInput [matDatepicker]="duePicker" [(ngModel)]="dueDate">
    <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
    <mat-datepicker #duePicker></mat-datepicker>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="submit()">Save</button>
</mat-dialog-actions>
